import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { ILeadKanbanResponse } from "../models/Lead";
import { DefaultResponseWithData } from "../models/system";
import apiConfig from "../utils/apiConfig";

// Fetches the leads for the collections board, oldest-first and capped at `max` cards per column.
// `query` is applied server-side (VRM / customer name / postcode) so searching reaches leads that
// sit beyond the cap rather than only filtering what's already on screen.
export default function useLeadKanban(max: number = 25, query: string = "") {
  const { get } = useApiHelper(apiConfig("useLeadKanban"));

  const kanban = useQuery(
    ["lead", "kanban", max, query],
    () =>
      get<DefaultResponseWithData<ILeadKanbanResponse>>(
        `/lead/kanban?max=${max}&query=${encodeURIComponent(query)}`
      ),
    {
      staleTime: 1000 * 60 * 2, // 2 minutes
      refetchInterval: 1000 * 60 * 5, // 5 minutes
      keepPreviousData: true, // keeps the board on screen while a search re-fetches
    }
  );

  return { kanban };
}
